<template>
  <div id="app">
    <el-menu
      v-if="showMenu"
      :default-active="activeMenu"
      mode="horizontal"
      router
      class="main-menu">
      <el-menu-item index="/vehicle-trade/list">
        <i class="el-icon-document"></i>
        <span>交易申请</span>
      </el-menu-item>
      <el-menu-item index="/user/list">
        <i class="el-icon-user"></i>
        <span>用户管理</span>
      </el-menu-item>
      <el-menu-item style="float: right;" @click="handleLogout">
        <i class="el-icon-switch-button"></i>
        <span>退出登录</span>
      </el-menu-item>
    </el-menu>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    activeMenu() {
      return this.$route.path
    },
    showMenu() {
      return this.$route.path !== '/login'
    }
  },
  methods: {
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        this.$message.success('已退出登录')
        this.$router.push('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main-menu {
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 20px;
}
</style>

